module.exports = __webpack_public_path__ + "img/rascrut-1.125b1c80.jpg";